'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import * as React from 'react'

// lib
import Box, { BoxProps } from '../box'

/* -----------------------------------------------------------------------------
 * SelectMenu
 * -------------------------------------------------------------------------- */

const SelectMenu = React.forwardRef<HTMLElement, BoxProps>(
  (props: BoxProps, ref) => (
    <Box
      bg='white'
      borderRadius='small'
      boxShadow='medium'
      height={{ mobile: '100%', tablet: 'auto' }}
      position='absolute'
      px={'20'}
      py={'16'}
      ref={ref}
      width={{ mobile: '100%', tablet: 'auto' }}
      {...props}
    />
  )
)

export default SelectMenu
